import type { ReactNode, Ref } from 'react';
import { ChevronDown } from 'lucide-react';
import { STEP_LABELS, type StepId, type StepInfo } from '../../lib/preflightSteps';
import { STATE_TEXT, StepGlyph } from './StepGlyph';

/** One accordion step: a head button (aria-expanded) and a body that is inert while closed. */
export function ChecklistStep({
  id,
  info,
  open,
  disabled,
  onToggle,
  headRef,
  children,
}: {
  id: StepId;
  info: StepInfo;
  open: boolean;
  disabled?: boolean | undefined;
  onToggle: () => void;
  headRef?: Ref<HTMLButtonElement> | undefined;
  children: ReactNode;
}) {
  return (
    <li className={`pf-step${open ? ' pf-open' : ''}`} data-s={info.state} data-step={id}>
      <button
        ref={headRef}
        type="button"
        className="pf-step-head"
        id={`pf-h-${id}`}
        data-step-head={id}
        aria-expanded={open}
        aria-controls={`pf-b-${id}`}
        disabled={disabled}
        onClick={onToggle}
      >
        <StepGlyph state={info.state} />
        <span style={{ minWidth: 0 }}>
          <span className="pf-lbl">
            {STEP_LABELS[id]}
            <span className="pf-sr">, {STATE_TEXT[info.state]}</span>
          </span>
          <span className="pf-sum">{info.summary}</span>
        </span>
        <span className="pf-meta">
          {info.tag ? (
            <span className={`pf-tag ${info.tag === 'Missing' ? 'pf-tag-todo' : 'pf-tag-warn'}`}>
              {info.tag}
            </span>
          ) : null}
          <ChevronDown className="pf-chev" aria-hidden="true" />
        </span>
      </button>
      <div className="pf-step-body" id={`pf-b-${id}`} inert={!open}>
        <div className="pf-step-inner">
          <div className="pf-pad">{children}</div>
        </div>
      </div>
    </li>
  );
}
